import type { ChangeEvent, ReactNode } from "react";

interface InputFieldProps {
  id: string;
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  icon?: ReactNode;
  autoComplete?: string;
  inputMode?: "text" | "search" | "email" | "tel" | "url" | "none" | "numeric" | "decimal";
  maxLength?: number;
}

export const InputField = ({
  id,
  label,
  type = "text",
  placeholder = "",
  value,
  autoComplete = "off",
  onChange,
  icon,
  inputMode = "text",
  maxLength = 255,
}: InputFieldProps) => (
  <div className="w-full relative">
    <label
      htmlFor={id}
      className="block mb-2 text-sm font-medium text-gray-900"
    >
      {label}
    </label>
    {icon && (
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
        {icon}
      </div>
    )}
    <input
      type={type}
      id={id}
      inputMode={inputMode}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-z-dark-moss-green  focus:border-z-dark-moss-green block w-full p-2.5 ${icon ? "pl-10" : ""}`}
      placeholder={placeholder}
      maxLength={maxLength}
    />
  </div>
);
